import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgUnknown = (props: ToothSvgComponentProps) => (
  <svg
    width={19 * (props.wx ?? 1)}
    height={27 * (props.hx ?? 1)}
    viewBox="0 0 19 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <mask
      id="path-1-outside-1_2161_1406"
      maskUnits="userSpaceOnUse"
      x="0.0541382"
      y="0"
      width="19"
      height="27"
      fill="black"
    >
      <rect fill="white" x="0.0541382" width="19" height="27" />
      <path d="M9.35542 1.80476C10.6882 1.80476 14.1544 -0.118494 16.1567 1.98137C17.7609 3.66421 17.1685 7.71066 16.0188 10.4346C15.5909 11.4477 15.6094 12.704 15.695 13.8779C16.0388 18.5799 14.5049 25.8182 13.1027 25.7335C11.6648 25.6464 11.7937 17.0265 9.62311 16.2744C8.35501 15.835 8.05926 18.0952 7.77778 20.2118C7.44114 22.7439 7.63941 25.3884 6.92381 25.6597C6.09077 25.9753 4.51028 23.855 3.67058 20.0037C3.21935 17.9343 3.02488 15.5964 3.08194 13.9069C3.11902 12.8135 3.12045 11.4481 2.69252 10.4351C1.54233 7.71161 0.949886 3.66469 2.55463 1.98185C4.55688 -0.118018 8.02265 1.80476 9.35542 1.80476Z" />
    </mask>
    <path
      d="M9.35542 1.80476C10.6882 1.80476 14.1544 -0.118494 16.1567 1.98137C17.7609 3.66421 17.1685 7.71066 16.0188 10.4346C15.5909 11.4477 15.6094 12.704 15.695 13.8779C16.0388 18.5799 14.5049 25.8182 13.1027 25.7335C11.6648 25.6464 11.7937 17.0265 9.62311 16.2744C8.35501 15.835 8.05926 18.0952 7.77778 20.2118C7.44114 22.7439 7.63941 25.3884 6.92381 25.6597C6.09077 25.9753 4.51028 23.855 3.67058 20.0037C3.21935 17.9343 3.02488 15.5964 3.08194 13.9069C3.11902 12.8135 3.12045 11.4481 2.69252 10.4351C1.54233 7.71161 0.949886 3.66469 2.55463 1.98185C4.55688 -0.118018 8.02265 1.80476 9.35542 1.80476Z"
      fill={props.fill || '#E4E4E7'}
    />
    <path
      d="M9.35542 1.80476C10.6882 1.80476 14.1544 -0.118494 16.1567 1.98137C17.7609 3.66421 17.1685 7.71066 16.0188 10.4346C15.5909 11.4477 15.6094 12.704 15.695 13.8779C16.0388 18.5799 14.5049 25.8182 13.1027 25.7335C11.6648 25.6464 11.7937 17.0265 9.62311 16.2744C8.35501 15.835 8.05926 18.0952 7.77778 20.2118C7.44114 22.7439 7.63941 25.3884 6.92381 25.6597C6.09077 25.9753 4.51028 23.855 3.67058 20.0037C3.21935 17.9343 3.02488 15.5964 3.08194 13.9069C3.11902 12.8135 3.12045 11.4481 2.69252 10.4351C1.54233 7.71161 0.949886 3.66469 2.55463 1.98185C4.55688 -0.118018 8.02265 1.80476 9.35542 1.80476Z"
      stroke={props.stroke || '#A1A1AA'}
      strokeWidth="2"
      strokeLinejoin="round"
      mask="url(#path-1-outside-1_2161_1406)"
    />

    <mask
      id="mask0_2161_1406"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="1"
      y="1"
      width="17"
      height="25"
    >
      <path
        d="M9.35542 1.80476C10.6882 1.80476 14.1544 -0.118494 16.1567 1.98137C17.7609 3.66421 17.1685 7.71066 16.0188 10.4346C15.5909 11.4477 15.6094 12.704 15.695 13.8779C16.0388 18.5799 14.5049 25.8182 13.1027 25.7335C11.6648 25.6464 11.7937 17.0265 9.62311 16.2744C8.35501 15.835 8.05926 18.0952 7.77778 20.2118C7.44114 22.7439 7.63941 25.3884 6.92381 25.6597C6.09077 25.9753 4.51028 23.855 3.67058 20.0037C3.21935 17.9343 3.02488 15.5964 3.08194 13.9069C3.11903 12.8135 3.12045 11.4481 2.69252 10.4351C1.54234 7.71161 0.949888 3.66469 2.55463 1.98185C4.55688 -0.118018 8.02312 1.80523 9.35589 1.80523L9.35542 1.80476Z"
        fill={props.fill || '#E4E4E7'}
      />
    </mask>
    <g mask="url(#mask0_2161_1406)">
      <line
        x1="-42.7526"
        y1="50.2945"
        x2="32.1629"
        y2="-24.621"
        stroke={props.findingsFill || '#FF5140'}
        strokeWidth="1.5"
      />
      <line
        x1="-35.6926"
        y1="50.2945"
        x2="39.2229"
        y2="-24.621"
        stroke={props.findingsFill || '#FF5140'}
        strokeWidth="1.5"
      />
      <line
        x1="-28.6326"
        y1="50.2945"
        x2="46.2829"
        y2="-24.621"
        stroke={props.findingsFill || '#FF5140'}
        strokeWidth="1.5"
      />
      <line
        x1="-21.5726"
        y1="50.2945"
        x2="53.3429"
        y2="-24.621"
        stroke={props.findingsFill || '#FF5140'}
        strokeWidth="1.5"
      />
      <line
        x1="-14.5126"
        y1="50.2945"
        x2="60.4029"
        y2="-24.621"
        stroke={props.findingsFill || '#FF5140'}
        strokeWidth="1.5"
      />
    </g>
  </svg>
);

export default SvgUnknown;
